<template>
  <div
    :class="[
      $style.button,
      {
        [$style.buttonStandAlone]: languages.length === 1,
      },
    ]"
    @click="languages.length === 1 && openUrl(languages[0].url)"
  >
    <span :class="$style.inactive">
      <Flag :class="$style.flag" :flag="flag" size="md" />
      {{ country }}
    </span>
    <span :class="$style.active"
      >{{ label }}
      <a
        v-for="(language, index) in languages"
        :key="index"
        :href="language.url"
        :title="language.title"
      >
        <Flag :class="$style.flag" :flag="language.flag" size="xs" />
      </a>
      {{ country }}
    </span>
  </div>
</template>

<script setup>
import Flag from '../Flag/Flag.vue';

defineProps({
  languages: {
    type: Array,
    default: () => [],
  },
  country: {
    type: String,
    default: '',
  },
  flag: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
});

const openUrl = (url) => {
  window.location.href = url;
};
</script>

<style module lang="scss">
@forward './CountryButton.scss';
</style>
